export default "__VITE_ASSET__DzHOBnBa__"